import { render, staticRenderFns } from "./skilledKnowledge.vue?vue&type=template&id=dd1ccc4e&scoped=true"
import script from "./skilledKnowledge.vue?vue&type=script&lang=js"
export * from "./skilledKnowledge.vue?vue&type=script&lang=js"
import style0 from "./skilledKnowledge.vue?vue&type=style&index=0&id=dd1ccc4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1ccc4e",
  null
  
)

export default component.exports